<template>
  <div class="wraper">
    <div class="warp">
      <!-- 面包屑 -->
      <!-- <breadcrumb :back="false" :crubList="[{name:'数据统计'},{name:'担保服务统计'}]" :title="'担保服务统计'" /> -->
      <el-tabs v-model="activeName" class="super_tab">
        <el-tab-pane label="业务统计" name="1">
          <!-- 统计 -->
          <div class="statistics">
            <div class="staTitle">担保申请统计</div>
            <ul>
              <li>
                <div class="name">申请担保</div>
                <div class="num">
                  {{statisticalNum.applyNumber}}
                  <span>个</span>
                </div>
              </li>
              <li>
                <div class="name">审核中</div>
                <div class="num">
                  {{statisticalNum.applyUnderReviewNumber}}
                  <span>个</span>
                </div>
              </li>
              <li>
                <div class="name">审核通过</div>
                <div class="num">
                  {{statisticalNum.applyThroughNumber}}
                  <span>个</span>
                </div>
              </li>
              <li>
                <div class="name">审核未通过</div>
                <div class="num">
                  {{statisticalNum.applyDidNotPassNumber}}
                  <span>个</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="statistics">
            <div class="staTitle">担保进度统计</div>
            <ul>
              <li>
                <div class="name">放款金额</div>
                <div class="num">
                  {{statisticalNum.loanAmount}}
                  <span>万元</span>
                </div>
              </li>
              <li>
                <div class="name">保后管理</div>
                <div class="num">
                  {{statisticalNum.applyGuaranteeRearNumber}}
                  <span>个</span>
                </div>
              </li>
              <li>
                <div class="name">银行放款</div>
                <div class="num">
                  {{statisticalNum.applyBankLendingNumber}}
                  <span>个</span>
                </div>
              </li>
              <li>
                <div class="name">签订协议</div>
                <div class="num">
                  {{statisticalNum.applySignProtocolNumber}}
                  <span>个</span>
                </div>
              </li>
              <li>
                <div class="name">银行上会审批</div>
                <div class="num">
                  {{statisticalNum.applyBankApprovalNumber}}
                  <span>个</span>
                </div>
              </li>
              <li>
                <div class="name">担保上会审批</div>
                <div class="num">
                  {{statisticalNum.applyVouchApprovalNumber}}
                  <span>个</span>
                </div>
              </li>
              <li>
                <div class="name">尽职调查</div>
                <div class="num">
                  {{statisticalNum.applySurveyNumber}}
                  <span>个</span>
                </div>
              </li>
              <li>
                <div class="name">担保公司受理</div>
                <div class="num">
                  {{statisticalNum.applyAcceptNumber}}
                  <span>个</span>
                </div>
              </li>
              <li>
                <div class="name">担保失败</div>
                <div class="num">
                  {{statisticalNum.applyVouchFailNumber}}
                  <span>个</span>
                </div>
              </li>
            </ul>
          </div>
          <!-- 查询条件 -->
          <div class="retrieve border">
            <div class="left">
              <div class="child">
                <span class="name">筛选日期</span>
                <el-date-picker
                  size="small"
                  v-model="sendInfoOne.time"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </div>
              <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn">查询</el-button>
              <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
            </div>
            <div class="right">
              <el-button
                icon="m-icon-upload"
                size="small"
                @click="exportFile"
                v-if="authorities.indexOf('sys:permission:background:guarantee:statistics:list:button:export')!=-1"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格 -->
          <el-table :data="tableData" fit
                :header-cell-style="headerStyle" style="width: 100%">
            <el-table-column prop="date" show-overflow-tooltip  label="日期"></el-table-column>
            <el-table-column prop="applyNumber" show-overflow-tooltip  label="申请担保数"></el-table-column>
            <el-table-column prop="views" show-overflow-tooltip  label="担保公司浏览详情数"></el-table-column>
            <el-table-column
              prop="grandTotalApplyNumber"
              show-overflow-tooltip
              
              label="累积申请担保数"
            ></el-table-column>
            <el-table-column
              prop="totalViews"
              show-overflow-tooltip
              
              label="累积担保公司浏览详情数"
            ></el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pagination">
            <Paging
              :PageData="PageData"
              @nextpage="nextpage"
              @previouspage="previouspage"
              @handleSizeChange="handleSizeChange"
              @handleCurrentChange="handleCurrentChange"
            ></Paging>
          </div>
        </el-tab-pane>
        <el-tab-pane label="处理统计" name="2">
          <div class="retrieve border">
            <div class="left">
              <div class="child">
                <span class="name">筛选日期</span>
                <el-date-picker
                  size="small"
                  v-model="phaseTime"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </div>
              <el-button type="primary" size="small" @click="phaseSearch" class="retrievalBtn">查询</el-button>
              <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
            </div>
          </div>
          <statistics
            :text="statData1"
            :dataList="statContent1"
            :defaultText="statDef1"
            @showSearchtable="changeDialog"
          ></statistics>
          <statistics
            :text="statData2"
            :dataList="statContent2"
            :defaultText="statDef2"
            @showSearchtable="changeDialog"
          ></statistics>
          <statistics
            :text="statData3"
            :dataList="statContent3"
            :defaultText="statDef3"
            @showSearchtable="changeDialog"
          ></statistics>
        </el-tab-pane>
      </el-tabs>
    </div>
    <statisticsTable
      :showDialog="showDialog"
      :showType="showType"
      :showTable="showTable"
      @sureData="sureData"
    ></statisticsTable>
  </div>
</template>

<script>
// import breadcrumb from "../../components/breadcrumb";
import Paging from "../../components/Paging";
import statistics from "@/components/statistics";
import statisticsTable from "@/components/statisticsTable";
export default {
  components: {
    // breadcrumb,
    Paging,
    statistics,
    statisticsTable
  },
  data() {
    return {
      authorities: JSON.parse(window.localStorage.getItem("authorities")),
      sendInfoOne: {
        time: "" //日期
      }, //搜索
      sendInfo: {
        currentPage: 1, //当前页
        pageSize: 10, //页条数
        property: null, //排序字段
        direction: "DESC", //排序排序方式DESC降 ASC升
        endDate: null, //结束时间
        startDate: null //开始时间
      },
      exportInfo: {
        endDate: null, //结束时间
        startDate: null //开始时间
      },
      PageData: {
        currentPage: 0,
        total: 0 //多少條
      },
      statisticalNum: [], //用户角色统计
      tableData: [], //表格
      currentPage: 1, //当前页
      // 二期二阶段新增内容
      activeName: "1",
      // statistics 数据
      statData1: {
        title: "其它担保公司处理统计",
        bTitle: "筛选担保公司",
        type: "1",
        url: "rpc/screening/guarantee",
        sort: 1,
        method: "guaranteeDeal",
        ChangeTitle: "",
        name: "statData1"
      },
      statContent1: { data: "" },
      statDef1: [{ type: "data", unit: "小时", name: "平均处理时间" }],
      tableList1: [
        { name: "账号ID", key: "id" },
        { name: "账号", key: "userName" },
        { name: "绑定手机号", key: "phone" },
        { name: "企业全称", key: "companyName" },
        { name: "客户经理", key: "customerManager" },
        { name: "账号状态", key: "statusName" }
      ],
      //
      statData2: {
        title: "担保业务申请审核统计",
        bTitle: "筛选管理员",
        type: "2",
        url: "backstage/administrator",
        sort: 2,
        method: "guaranteeApply",
        ChangeTitle: "",
        name: "statData2"
      },
      statContent2: {},
      statDef2: [
        { type: "audited", unit: "个", name: "已审核" },
        { type: "approved", unit: "个", name: "审核通过" },
        { type: "notApproved", unit: "个", name: "审核未通过" },
        { type: "time", unit: "小时", name: "平均处理时间" }
      ],
      tableList2: [
        { name: "管理员编号", key: "id" },
        { name: "账号", key: "userName" },
        { name: "姓名", key: "realName" },
        { name: "管理员类型", key: "administratorType" },
        { name: "账号状态", key: "statusName" }
      ],
      //
      statData3: {
        title: "经开区中小担保处理统计",
        bTitle: "筛选管理员",
        type: "2",
        url: "backstage/administrator",
        sort: 3,
        method: "guaranteeWith",
        ChangeTitle: "",
        name: "statData3"
      },
      statContent3: { data: "" },
      statDef3: [{ type: "data", unit: "小时", name: "平均处理时间" }],
      tableList3: [
        { name: "管理员编号", key: "id" },
        { name: "账号", key: "userName" },
        { name: "姓名", key: "realName" },
        { name: "管理员类型", key: "administratorType" },
        { name: "账号状态", key: "statusName" }
      ],
      // 数据弹框 showDialog
      showDialog: { type: false, url: "", text: "",name:"" },

      showType: "1",
      showTable: [],
      // phaseTime 二期时间
      phaseTime: [],
      phaseFormData: {
        endDate: "",
        startDate: "",
        userIds: []
      },
      methodName: ""
    };
  },
  methods: {
    onReset(){
      if(this.activeName === '1'){
        const param = {
          currentPage: 1, //当前页
          pageSize: 10, //页条数
          property: null, //排序字段
          direction: "DESC", //排序排序方式DESC降 ASC升
          endDate: null, //结束时间
          startDate: null //开始时间
        }
        this.sendInfo = Object.assign(this.sendInfo,param)
        this.sendInfoOne.time = void 0
        this.retrieval()
      }else{
        this.phaseTime = void 0
        this.phaseSearch()
      }
    },
    // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
    phaseSearch() {
      this.phaseFormData.userIds = [];
      if (this.phaseTime) {
        if (this.phaseTime.length === 2) {
          this.phaseFormData.startDate = this.phaseTime[0];
          this.phaseFormData.endDate = this.phaseTime[1];
        }
      } else {
        this.phaseFormData.startDate = null;
        this.phaseFormData.endDate = null;
      }
      this.guaranteeWith();
      this.guaranteeApply();
      this.guaranteeDeal();
    },
    // 经开区中小担保处理统计
    guaranteeWith() {
      let obj = Object.assign({}, this.phaseFormData);
      obj["loadIds"] = obj.userIds;
      Reflect.deleteProperty(obj, "userIds");
      this.$axiosc
        .get("backstage/statistics/small/guarantee/deal/with", {
          params: obj
        })
        .then(r => {
          this.statDef3[0].unit = r.data.unit;
          this.statContent3.data = r.data.data;
        });
    },
    // 担保业务申请审核统计
    guaranteeApply() {
      this.$axiosc
        .get("backstage/statistics/guarantee/apply", {
          params: this.phaseFormData
        })
        .then(r => {
          if (r.data.time) {
            this.statDef2[3].unit = r.data.time.unit;
            r.data.time = r.data.time.data;
          }

          this.statContent2 = r.data;
        });
    },
    // 其它担保公司处理统计
    guaranteeDeal() {
      let obj = Object.assign({}, this.phaseFormData);
      obj["loadIds"] = obj.userIds;
      Reflect.deleteProperty(obj, "userIds");
      this.$axiosc
        .get("backstage/statistics/guarantee/deal/with", {
          params: obj
        })
        .then(r => {
          this.statDef1[0].unit = r.data.unit;
          this.statContent1.data = r.data.data;
        });
    },
    // table 弹框选中值
    sureData(data) {
       this.phaseFormData.userIds = data.data;
this[data.name].ChangeTitle = data.text;

      this[this.methodName]();
    },
    changeDialog(data) {
      this.showDialog.type = true;
      this.showDialog.url = data.url;
      this.showType = data.type;
      this.showDialog.text = data.bTitle;
this.showDialog.name = data.name;

      this.showTable = this["tableList" + [data.sort]];
      this.methodName = data.method;
    },
    //统计
    statistical: function() {
      this.$axiosc.get("backstage/statistics/vouch").then(r => {
        if (r.code == 200) {
          this.statisticalNum = r.data;
        } else {
          this.$alert(r.msg);
        }
      });
    },
    //获取列表
    getList: function() {
      this.$axiosc
        .get("backstage/statistics/vouch/list", { params: this.sendInfo })
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data.content;
            this.PageData.currentPage = res.data.currentPage; //当前页
            this.PageData.total = res.data.totalElements;
          } else {
            this.$alert(res.msg);
          }
        });
    },
    //导出
    exportFile: function() {
      this.dateToConversion();
      this.$axiosc
        .get("backstage/statistics/vouch/list/export", {
          params: this.exportInfo
        })
        .then(res => {
          if (res.code == 200) {
            var aLink = document.createElement("a");
            var blob = this.dataURLtoBlob(res.data.bytes);
            var reader = new FileReader();
            reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
            reader.onload = function(e) {
              var a = document.createElement("a"); // 转换完成，创建一个a标签用于下载
              a.download = res.data.fileName;
              a.href = e.target.result;
              document.body.appendChild(a); // 修复firefox中无法触发click
              a.click();
              document.body.removeChild(a);
            };
          } else {
            this.$alert(res.msg);
          }
        });
    },
    dataURLtoBlob: function(dataurl) {
      let bstr = atob(dataurl), //负责解码已经使用base64编码了的字符串
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: "application/vnd.ms-excel;charset=UTF-8;"
      });
    },
    //查询
    retrieval: function() {
      this.dateToConversion();
      this.getList();
    },
    //日期转换
    dateToConversion: function() {
      let lookData = this.sendInfoOne;
      if (lookData.time && lookData.time.length > 0) {
        this.sendInfo.startDate = lookData.time[0];
        this.sendInfo.endDate = lookData.time[1];
        this.exportInfo.startDate = lookData.time[0];
        this.exportInfo.endDate = lookData.time[1];
      } else {
        this.sendInfo.startDate = null;
        this.sendInfo.endDate = null;
        this.exportInfo.startDate = null;
        this.exportInfo.endDate = null;
      }
    },

    // 下一頁
    nextpage(val) {
      this.sendInfo.currentPage = val;
      this.getList();
    },
    // 上一頁
    previouspage(val) {
      this.sendInfo.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.sendInfo.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.sendInfo.currentPage = val;
      this.sendInfo.currentPage = val;
      this.getList();
    }
  },
  created() {
    this.statistical();
    this.getList();
    this.guaranteeWith();
    this.guaranteeApply();
    this.guaranteeDeal();
  },
  computed: {
    errors() {
      return this.$vuerify.$errors; // 错误信息会在 $vuerify.$errors 内体现
    }
  }
};
</script>


<style lang="scss" scoped>
.wraper{
  height:calc(100% - 30px);
  padding:10px 20px 20px;
  
  .retrieve{
      justify-content: space-between;
      flex-direction: row;
    }
    .warp{
      height: 100%;
      .super_tab{
        height: 100%;
      }
    }
    /deep/ .el-tabs__content{
      height:calc(100% - 50px);
  overflow-x: hidden;
  overflow-y: auto;
    }
}
</style>